import { useFlowStore } from "@/stores/flow-store";
import { useShallow } from "zustand/shallow";
import { DesktopSidebarFragment } from "./fragments/desktop-sidebar-fragment";

export function SidebarModule() {
  const [activePanel, setActivePanel, isSidebarOpen, setSidebarOpen] = useFlowStore(
    useShallow((s) => [
      s.sidebar.active, 
      s.actions.sidebar.setActivePanel,
      s.sidebar.isOpen,
      s.actions.sidebar.setSidebarOpen
    ])
  );

  return (
    <DesktopSidebarFragment
      activePanel={activePanel}
      setActivePanel={setActivePanel}
      isSidebarOpen={isSidebarOpen}
      setSidebarOpen={setSidebarOpen}
    />
  );
}
